import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '../components/Navbar';
import axios from 'axios';
import ProductGrid from '../components/ProductGrid';

export const SearchPage = () => {
  const location = useLocation();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  // Extract query parameters
  const searchParams = new URLSearchParams(location.search);
  const searchQuery = searchParams.get('query');
  const resultQuery = searchParams.get('result');
  const id = searchParams.get('id');

  // Fetch data on component mount or when query parameters change
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);

      try {
        let endpoint;

        // Determine endpoint based on query presence
        if (searchQuery) {
          endpoint = `${process.env.REACT_APP_API_URL}product/searchbytag/${searchQuery}`;
        } else if (resultQuery === 'category' && id) {
          endpoint = `${process.env.REACT_APP_API_URL}product/categoryProducts/${id}`;
        } else if (resultQuery === 'subcategory' && id) {
          endpoint = `${process.env.REACT_APP_API_URL}product/subcategoryProducts/${id}`;
        } else {
          setProducts([]);
          setLoading(false);
          return;
        }

        // Use Axios to fetch data
        const response = await axios.get(endpoint);
        setProducts(response.data);
      } catch (error) {
        console.error('Error fetching data:', error);
        setProducts([]);
      } finally {
        setLoading(false);
      }
    };

    // Fetch data when relevant parameters are present
    if (searchQuery || (id && resultQuery)) {
      fetchData();
    }
  }, [searchQuery, id, resultQuery]);

  return (
    <div>
      <div style={{ marginTop: '8rem' }}>
        {loading ? (
          <p>Loading...</p>
        ) : products.length > 0 ? (
          <ProductGrid section="Search result" products={products} />
        ) : (
          <p>No products found</p>
        )}
      </div>
    </div>
  );
};
